import React, { useContext } from "react";
import ModalMain from "../../../../components/Modal/ModalMain";
import ModalFooter from "../../../../components/Modal/ModalFooter";
import ModalHeader from "../../../../components/Modal/ModalHeader";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import { t } from "i18next";
import themeContext from "../../../../context/theme/ThemeContext";
import userContext from "../../../../context/users/UserContext";
import { USERTYPES } from "../../../../constants/Constants";

const ShortcutKeyModal = ({ isSharedStudyViewer }) => {

    const {setShowShortcutModal} = useContext(studyviewerContext);

    let DefaultButtonList = [
        {
          title: t("button.close"),
          onclick: () => {
            setShowShortcutModal(false);
          },
        },
      ];

    const modalDetails = {
        header: (
          <ModalHeader
            updatedModal={true}
            heading="Shortcut Keys"
            handleCancel={() =>  setShowShortcutModal(false)}
          />
        ),
        body: <ShortcutKeyModalBody isSharedStudyViewer={isSharedStudyViewer}/>,
        footer: (
          <ModalFooter
            PrimaryButtonList={[]}
            DefaultButtonList={DefaultButtonList}
          />
        ),
        width: "700px",
      };
    
      return (
        <>
          <ModalMain
            updatedModal={true}
            modalDetails={modalDetails}
            showModal={true}
          />
        </>
      );
}

export default ShortcutKeyModal;

const ShortcutKeyModalBody = ({ isSharedStudyViewer }) => {

    const { getThemeColor,themeName,getScrollBarStyleForTheme } = useContext(themeContext);
    const {showSavedReport} = useContext(studyviewerContext);
    const {roles, privilegedFirmDoctor}=useContext(userContext);

    const containerStyle = {
        padding: '20px',
        lineHeight: '1.6',
        color: '#dcdcdc',
        maxHeight: '70vh',
        overflow: 'auto'
    };

    const headingStyle = {
        color: '#f5f5f5',
        marginBottom: '20px',
    };

    const sectionHeadingStyle = {
        color: '#ff9800',
        marginTop: '20px',
    };

    const codeStyle = {
        backgroundColor: getThemeColor("action-details-background"),
        padding: '10px',
        border: '1px solid #444',
        borderRadius: '5px',
        fontSize: '15px',
        marginBottom: '10px',
        color: getThemeColor("primary-color")
    };

    const keyStyle = {
      fontFamily: 'monospace',
      backgroundColor: '#444',
      padding: '2px 4px',
      borderRadius: '3px',
      color: '#ffcc00',
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginBottom: '20px',
  };

  const thStyle = {
      textAlign: 'left',
      color: '#ffcc00',
      paddingBottom: '10px',
      borderBottom: '2px solid #444',
  };

  const tdKeyStyle = {
      width: '20%',
      padding: '10px',
      border: '1px solid #444',
      backgroundColor: getThemeColor("action-details-background"),
      borderRadius: '5px',
      fontSize: '15px',
      color: themeName === "light"?"black":'#ffcc00',
      fontFamily: 'monospace',
  };

  const tdValueStyle = {
      width: '80%',
      padding: '10px',
      border: '1px solid #444',
      backgroundColor: getThemeColor("action-details-background"),
      borderRadius: '5px',
      fontSize: '15px',
      color:getThemeColor("primary-color"),
  };

    return (
      <div style={containerStyle} className={getScrollBarStyleForTheme(themeName,"common-modal-scroll")}>
      <h2 style={sectionHeadingStyle}>General Shortcuts</h2>
      <table style={tableStyle}>
          <tbody>
              <tr>
                  <td style={tdKeyStyle}><code>S</code></td>
                  <td style={tdValueStyle}>Open Series</td>
              </tr>
              {!isSharedStudyViewer &&
                roles?.[0]?.includes &&
                (!roles[0].includes(USERTYPES.FIRMDOCTOR) || showSavedReport) && (
                    <tr>
                    <td style={tdKeyStyle}><code>R</code></td>
                    <td style={tdValueStyle}>Open Report</td>
                    </tr>
                )}
              <tr>
                  <td style={tdKeyStyle}><code>Up Arrow</code></td>
                  <td style={tdValueStyle}>Previous Image on Active Viewport</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>Down Arrow</code></td>
                  <td style={tdValueStyle}>Next Image on Active Viewport</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>Right Arrow</code></td>
                  <td style={tdValueStyle}>Change Series to Next Series in Active Viewport</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>Left Arrow</code></td>
                  <td style={tdValueStyle}>Change Series to Previous Series in Active Viewport</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>I</code></td>
                  <td style={tdValueStyle}>Invert Image</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>H</code></td>
                  <td style={tdValueStyle}>Horizontal Flip</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>V</code></td>
                  <td style={tdValueStyle}>Vertical Flip</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>Shift + D, Delete</code></td>
                  <td style={tdValueStyle}>Delete Selected measurement</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>Ctrl/Cmd + Delete</code></td>
                  <td style={tdValueStyle}>Delete All</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>Y</code></td>
                  <td style={tdValueStyle}>Stack Scroll</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>W</code></td>
                  <td style={tdValueStyle}>Window Level</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>Z</code></td>
                  <td style={tdValueStyle}>Zoom</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>Ctrl/Cmd + K</code></td>
                  <td style={tdValueStyle}>Mark as Key Object (KO)</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>Shift + G</code></td>
                  <td style={tdValueStyle}>Save viewport content as Secondary Capture DICOM</td>
              </tr>
          </tbody>
      </table>

      <h2 style={sectionHeadingStyle}>Multi-frame Playback (Cine)</h2>
      <table style={tableStyle}>
          <tbody>
              <tr>
                  <td style={tdKeyStyle}><code>Space</code></td>
                  <td style={tdValueStyle}>Play / Pause multi-frame playback on Active Viewport</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>Left Arrow / Up Arrow</code></td>
                  <td style={tdValueStyle}>Previous frame (multi-frame viewport only)</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>Right Arrow / Down Arrow</code></td>
                  <td style={tdValueStyle}>Next frame (multi-frame viewport only)</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>Home</code></td>
                  <td style={tdValueStyle}>Jump to first frame</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>End</code></td>
                  <td style={tdValueStyle}>Jump to last frame</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>+</code></td>
                  <td style={tdValueStyle}>Increase FPS by 1 (Shift +5)</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>−</code></td>
                  <td style={tdValueStyle}>Decrease FPS by 1 (Shift −5)</td>
              </tr>
          </tbody>
      </table>

      <h2 style={sectionHeadingStyle}>Measurement Tool Shortcuts</h2>
      <table style={tableStyle}>
          <tbody>
              <tr>
                  <td style={tdKeyStyle}><code>L</code></td>
                  <td style={tdValueStyle}>Length</td>
              </tr>
              <tr>
                 <td style={tdKeyStyle}><code>E</code></td>
                 <td style={tdValueStyle}>Ellipse</td>
              </tr>
              <tr>
                 <td style={tdKeyStyle}><code>f</code></td>
                 <td style={tdValueStyle}>Image Enhancement</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>A</code></td>
                  <td style={tdValueStyle}>Angle Measurement</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>C</code></td>
                  <td style={tdValueStyle}>Cobb Angle Measurement</td>
              </tr>
          </tbody>
      </table>   
      {/* <h2 style={sectionHeadingStyle}>Window Level Tools Shortcuts</h2>
      <table style={tableStyle}>
          <tbody>
              <tr>
                  <td style={tdKeyStyle}><code>0</code></td>
                  <td style={tdValueStyle}>Reset WW/WC</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>l</code></td>
                  <td style={tdValueStyle}>Length</td>
              </tr>
              <tr>
                 <td style={tdKeyStyle}><code>e</code></td>
                 <td style={tdValueStyle}>Ellipse</td>
              </tr>
          </tbody>
      </table> */}

      <h2 style={sectionHeadingStyle}>Voice Assistant Shortcuts</h2>
      <table style={tableStyle}>
          <tbody>
              <tr>
                  <td style={tdKeyStyle}><code>Ctrl + Space</code></td>
                  <td style={tdValueStyle}>Toggle Voice Assistant</td>
              </tr>
          </tbody>
      </table>

      <h2 style={sectionHeadingStyle}>CT/MR Specific Shortcuts</h2>
      <table style={tableStyle}>
          <tbody>
              <tr>
                  <td style={tdKeyStyle}><code>0</code></td>
                  <td style={tdValueStyle}>Reset WW/WC</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>1</code></td>
                  <td style={tdValueStyle}>Abdomen</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>2</code></td>
                  <td style={tdValueStyle}>Angio</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>3</code></td>
                  <td style={tdValueStyle}>Bone</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>4</code></td>
                  <td style={tdValueStyle}>Brain</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>5</code></td>
                  <td style={tdValueStyle}>Chest</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>6</code></td>
                  <td style={tdValueStyle}>Lungs</td>
              </tr>
          </tbody>
      </table>
  </div>
    );
}